/*
 * /songs (page)
 */
import { createFileRoute } from "@tanstack/react-router"
import { Container, Divider, Page, PageHeader, Skeleton } from "@psychology/react-ui"
import { ArrowLeft } from "lucide-react"
import { useTranslation } from "react-i18next"
import { v4 as uuidv4 } from "uuid"
import { UserSongsList } from "../../features/songs/components/user-songs-list"
import { trpc } from "../../trpc"
import { authPageLoader } from "../../utils/auth.utils"

export const Route = createFileRoute("/songs/")({
	component: SongsPage,
	loader: authPageLoader,
})

function SongsPage() {
	const { t } = useTranslation()
	const { user } = Route.useLoaderData()

	const newId = uuidv4()

	const { data: userSongs, isLoading } = trpc.userSong.getAllByFilter.useQuery({
		where: { userId: user.id },
		sort: { column: "createdAt", direction: "desc" },
	})

	return (
		<Page centerVertical={false}>
			<Container width={"xl"} padding={"lg"} gap={"sm"}>
				<PageHeader
					title={t("features.songs.title")}
					left={{
						href: "/dashboard",
						label: t("nav.dashboard"),
						Icon: <ArrowLeft size={20} />,
					}}
				/>
				<Divider />
				{isLoading ? (
					<div className={"space-y-4"}>
						{[1, 2, 3].map((i) => (
							<Skeleton key={i} className={"h-[80px] w-full rounded-lg"} />
						))}
					</div>
				) : (
					<UserSongsList userSongs={userSongs || []} newId={newId} />
				)}
			</Container>
		</Page>
	)
}
